import { OccupationTitle, State, UserEmploymentStatus } from "@ctypes";

export const convertToStateCode = (input?: string | null) => {
  if (!input) return undefined;

  const state = input.replace(/\s/g, "");

  const longStateNames = Object.keys(State);
  const stateCodes = Object.values(State);

  const index = longStateNames.findIndex((s) => s === state);

  if (index === -1) return State.Alabama;

  return stateCodes[index];
};

export function requiresIndustryForAltruist(
  employmentStatus?: UserEmploymentStatus | null,
  occupationTitle?: OccupationTitle | null,
): boolean {
  if (employmentStatus === UserEmploymentStatus.SelfEmployed) {
    return true;
  }

  if (employmentStatus === UserEmploymentStatus.Employed && occupationTitle) {
    return (
      occupationTitle === OccupationTitle.BusinessExecutive ||
      occupationTitle === OccupationTitle.Consultant ||
      occupationTitle === OccupationTitle.BusinessOwner
    );
  }

  return false;
}
